<template>
  <section>
    <div class="content_bg">
      <div class="content">
        
        <div class="desc">
          이런 상황들이 먼데이리스에겐 없습니다.   <br/>
먼데이리스는 <span style="color:#002EFF">Seamless</span>하게 서버구성을 하며, <span style="color:#002EFF">Serverless / aws Lambda</span>를 사용하기 때문입니다. <br/>
서버와 DB 비용은 월 1000원부터 시작합니다. <br/>
사용자가 많아지면 자동으로 서버가 스케일링 됩니다. <br/>
비용은 전세계에서 가장 저렴한 AWS Cloud에서 결제됩니다 <br/>

        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";

export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 50px 20px 50px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.desc {
  font-weight: 300;
  font-size: 24px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 50px 20px 50px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  